import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import 'animate.css';
import 'jquery-nice-select/css/nice-select.css';

import 'bootstrap-icons/font/bootstrap-icons.css';
import 'boxicons/css/boxicons.min.css';

import './assets/css/style.css';
import './assets/css/nice-select.css';
import './assets/css/swiper-bundle.min.css';
import './assets/css/jquery.fancybox.min.css';
import './assets/css/animate.css';
import './assets/css/boxicons.min.css';
import './assets/css/bootstrap-icons.min.css';
import './assets/css/bootstrap.min.css';
import './assets/css/boxicons.min.css';
import '../emagazine/assets/css/new_style.css'

import BybFooter from '../../Components/BybMainPage/BybFooter/BybFooter.jsx';
import PageSeo from '../../Components/Common/Seo/PageSeo.jsx';
import { DarkContext } from './ThemeContext.jsx';
import { buildAuthorPath, getArticleAuthorName } from './authorData.js';
import { DEFAULT_OG_IMAGE, SITE_URL, stripHtml, toCanonicalUrl, toTitleCase } from '../../Components/Common/Seo/seoUtils.js';
import {
    buildEmagazineApiUrl,
    buildEmagazineArticlePath,
    buildEmagazineCategoryPath,
    buildEmagazineUploadUrl,
    resolveEmagazineCategoryParam,
    slugifyEmagazineCategory,
} from './emagazineApi.js';
import { EBOOK_CTA_TITLE, EBOOK_CTA_URL, getEbookCtaTrackingAttributes, trackEbookCtaClick } from './ebookCtaTracking.js';
//import '../../../src/pages/emagazine/assets/js/custom.js';

const getFirstPopulatedField = (source, fieldNames) => {
    if (!source) return "";

    for (const fieldName of fieldNames) {
        const value = source[fieldName];

        if (value !== undefined && value !== null && String(value).trim()) {
            return String(value).trim();
        }
    }

    return "";
};

const EMPTY_CATEGORY_COMING_SOON_SLUGS = new Set(["expert-talks", "podcast"]);

const CATEGORY_SEO_CONTENT = {
    "industry-news": {
        title: "Industry News | Branding & Business Updates | Brew Your Brand eMagazine",
        description: "Follow industry news on branding, marketing, consumer trends, and business shifts shaping how modern brands grow.",
        ogTitle: "Industry News from Brew Your Brand eMagazine",
        ogDescription: "Catch branding, marketing, consumer, and business news curated for founders, marketers, and brand teams.",
    },
    "strategy": {
        title: "Brand Strategy Articles | Brew Your Brand eMagazine",
        description: "Explore brand strategy articles on positioning, messaging, customer experience, differentiation, and growth decisions.",
        ogTitle: "Brand Strategy Insights from Brew Your Brand",
        ogDescription: "Read practical strategy ideas for clearer positioning, stronger messaging, and more consistent brand growth.",
    },
    "whats-buzzing": {
        title: "What's Buzzing in Branding | Brew Your Brand eMagazine",
        description: "Track trending brand stories, campaign ideas, culture shifts, and buzzworthy conversations from the branding world.",
        ogTitle: "What's Buzzing in Branding and Culture",
        ogDescription: "Discover trending brand stories, campaigns, cultural shifts, and fresh conversations worth watching now.",
    },
    "articles": {
        title: "Branding Articles | Brew Your Brand eMagazine",
        description: "Read branding articles with practical ideas on identity, storytelling, marketing, customer experience, and business growth.",
        ogTitle: "Branding Articles from Brew Your Brand eMagazine",
        ogDescription: "Explore practical articles on brand identity, storytelling, marketing, customer experience, and growth.",
    },
    "expert-talks": {
        title: "Expert Talks | Branding Interviews | Brew Your Brand eMagazine",
        description: "Read expert talks with founders, marketers, creators, and brand leaders sharing lessons on building memorable brands.",
        ogTitle: "Expert Talks with Brand Builders",
        ogDescription: "Learn from founders, marketers, creators, and experts sharing practical brand-building lessons and perspectives.",
    },
    "podcast": {
        title: "Branding Podcast | Brew Your Brand eMagazine",
        description: "Listen to podcast conversations on branding, marketing, entrepreneurship, creativity, and building stronger businesses.",
        ogTitle: "Brew Your Brand Podcast Episodes",
        ogDescription: "Hear conversations on branding, marketing, entrepreneurship, creativity, and business-building ideas.",
    },
};
const CategoryPage = () =>
{

    const [theme,setTheme] = useContext(DarkContext);

    const handleThemeSwitch = ()=>{
    console.log('theme switched');
        setTheme((prevtheme)=>prevtheme === 'dark' ? "light" : "dark")
            // setTheme(theme === 'dark' ? "#fff" : "#000")
}

    const location = useLocation();
    const navigate = useNavigate();
    const { categoryId } = useParams();
    const getCategoryHref = (name) => buildEmagazineCategoryPath(name);

    const category = resolveEmagazineCategoryParam(categoryId || "");
    const [posts, setPosts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [blogs, setBlogs] = useState([]);
    const [arePostsLoaded, setArePostsLoaded] = useState(false);
    const [areBlogsLoaded, setAreBlogsLoaded] = useState(false);
    const [subscriberEmail, setSubscriberEmail] = useState("");
    const [subscriberMessage, setSubscriberMessage] = useState("");
    const [subscriberMessageType, setSubscriberMessageType] = useState("");

    useEffect(() => {
        if (!categoryId || !category) return;

        const cleanCategoryPath = buildEmagazineCategoryPath(category);

        if (location.pathname !== cleanCategoryPath) {
            navigate(cleanCategoryPath, { replace: true });
        }
    }, [categoryId, category, location.pathname, navigate]);

    // Fetch posts by category
    useEffect(() => {
        const fetchPostsByCategory = async () => {
            setArePostsLoaded(false);

            if (!category) {
                setPosts([]);
                setArePostsLoaded(true);
                return;
            }

            try {
                const response = await fetch(
                    buildEmagazineApiUrl(`get_featured_blogs_by_category.php?category=${encodeURIComponent(category)}`)
                );
                const data = await response.json();

                setPosts(data.success ? data.blogs : []);
            } catch (error) {
                console.error("Error fetching posts:", error);
                setPosts([]);
            } finally {
                setArePostsLoaded(true);
            }
        };

        fetchPostsByCategory();
    }, [category]);
    // Fetch categories
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch(buildEmagazineApiUrl("get_categories.php"));
                const data = await response.json();

                if (data.success) {
                    setCategories(data.categories);
                } else {
                    console.error("Failed to fetch categories");
                }
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        fetchCategories();
    }, []);


    useEffect(() => {
        const fetchBlogs = async () => {
            setAreBlogsLoaded(false);

            if (!category) {
                setBlogs([]);
                setAreBlogsLoaded(true);
                return;
            }

            try {
                const response = await fetch(
                    buildEmagazineApiUrl(`get_blogs_by_category.php?category=${encodeURIComponent(category)}`)
                );
                const data = await response.json();

                if (data.success) {
                    setBlogs(data.blogs.slice(0, 10));
                } else {
                    console.error('No blogs found for category:', category);
                    setBlogs([]);
                }
            } catch (error) {
                console.error('Error fetching blogs:', error);
                setBlogs([]);
            } finally {
                setAreBlogsLoaded(true);
            }
        };

        fetchBlogs();
    }, [category]);


    const [showHamburgerMenu, setshowHamburgerMenu] = useState(false)
const handleHamburgerMenu = ()=>{
    setshowHamburgerMenu((preState)=>!preState)
    console.log('clicked');
}

const validateSubscriberEmail = (email) => /\S+@\S+\.\S+/.test(email);

const handleCategorySubscribe = async (event) => {
    event.preventDefault();

    if (!validateSubscriberEmail(subscriberEmail)) {
        setSubscriberMessage("Please enter a valid email address.");
        setSubscriberMessageType("error");
        return;
    }

    try {
        const response = await fetch(buildEmagazineApiUrl("subscriber-submit.php"), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: subscriberEmail }),
        });
        const data = await response.json();

        if (data.success) {
            setSubscriberMessage("Thank you for subscribing. We will share new eMagazine updates soon.");
            setSubscriberMessageType("success");
            setSubscriberEmail("");
        } else {
            setSubscriberMessage("Subscription failed. Please try again.");
            setSubscriberMessageType("error");
        }
    } catch (error) {
        setSubscriberMessage("Something went wrong. Please try again later.");
        setSubscriberMessageType("error");
    }
};
    const categoryName = toTitleCase(category);
    const categoryData = categories.find((item) => (
        String(item.name || "").toLowerCase() === String(category || "").toLowerCase()
    ));
    const categoryCmsDescription = stripHtml(getFirstPopulatedField(categoryData, [
        "description",
        "meta_description",
        "og_description",
        "summary",
        "excerpt",
    ]));
    const categorySlug = slugifyEmagazineCategory(category || categoryName);
    const categorySeo = CATEGORY_SEO_CONTENT[categorySlug];
    const categoryTitle = categorySeo?.title || `${categoryName} Articles | Brew Your Brand eMagazine`;
    const categoryDescription = categorySeo?.description
      || categoryCmsDescription
      || `Explore ${categoryName.toLowerCase()} articles, brand strategy insights, and practical resources from Brew Your Brand eMagazine.`;
    const categoryOgTitle = categorySeo?.ogTitle || categoryTitle;
    const categoryOgDescription = categorySeo?.ogDescription || categoryDescription;
    const isCategoryContentLoaded = arePostsLoaded && areBlogsLoaded;
    const hasCategoryContent = posts.length > 0 || blogs.length > 0;
    const showCategoryComingSoon = isCategoryContentLoaded
      && EMPTY_CATEGORY_COMING_SOON_SLUGS.has(categorySlug)
      && !hasCategoryContent;
    const categoryRobots = showCategoryComingSoon ? "noindex,follow" : "index,follow";
    const cleanCategoryPath = buildEmagazineCategoryPath(category);
    const categoryOgImage = blogs[0]?.image2
      ? buildEmagazineUploadUrl(blogs[0].image2)
      : posts[0]?.image3
        ? buildEmagazineUploadUrl(posts[0].image3)
        : DEFAULT_OG_IMAGE;
    const categorySchema = {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "@id": `${toCanonicalUrl(cleanCategoryPath)}#collection`,
      name: categoryTitle,
      description: categoryDescription,
      url: toCanonicalUrl(cleanCategoryPath),
      isPartOf: {
        "@type": "WebSite",
        "@id": `${SITE_URL}/#website`,
      },
      mainEntity: {
        "@type": "ItemList",
        itemListElement: blogs.slice(0, 10).map((blog, index) => ({
          "@type": "ListItem",
          position: index + 1,
          url: toCanonicalUrl(buildEmagazineArticlePath(blog.category, blog.slug)),
          name: blog.title,
        })),
      },
    };
    const categoryBreadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "@id": `${toCanonicalUrl(cleanCategoryPath)}#breadcrumb`,
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: toCanonicalUrl("/"),
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "BYB eMagazine",
          item: toCanonicalUrl("/e-magazine/"),
        },
        {
          "@type": "ListItem",
          position: 3,
          name: categoryName,
          item: toCanonicalUrl(cleanCategoryPath),
        },
      ],
    };

    return (
        <>
    <PageSeo
      title={categoryTitle}
      description={categoryDescription}
      canonical={cleanCategoryPath}
      ogTitle={categoryOgTitle}
      ogDescription={categoryOgDescription}
      ogImage={categoryOgImage}
      robots={categoryRobots}
      structuredData={[categorySchema, categoryBreadcrumbSchema]}
    />
    <div className={`${theme === 'dark' ? 'dark' : "add_light"}`} style={{backgroundColor:theme === 'dark' ? "#Fff" :"rgb(7, 26, 40)"}}>



        <div className={`${showHamburgerMenu ? "show-menu" : ""} sidebar-menu d-lg-none d-sm-block`}>
            <div className="mobile-logo-area d-flex justify-content-between align-items-center">
                <div className="header-logo cate">
                    <a href="/e-magazine/"><img alt="Brew Your Brand eMagazine logo" className="img-fluid dark" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg" /></a>
                    <a href="/e-magazine/"><img alt="Brew Your Brand eMagazine logo" className="img-fluid light" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg" /></a>
                </div>
                <div className="menu-button menu-close-btn" onClick={handleHamburgerMenu}>
                    <i className="bi bi-x"></i>
                </div>
            </div>

            <ul className="menu-list">
            {categories.map(category => (
    <li key={category.id}>
        <a href={getCategoryHref(category.name)}>
            {category.name}
        </a>
    </li>
))}


            </ul>

            <div className="menu-bottom-content">
                <div class="header-right">
                <a href="javascript:void(0)"  class="submit_quote" id="visual-projects">Submit Your Article</a>
                <li class=" " id="popup-container">
                    <div data-tf-live="01JSY0YC8JZVDTTCVBWM28RKPN" class="article_form"></div>
                 </li>
            </div>

            <div class="social-wrap">
                <h6>Follow Social Media </h6>
                <ul class="social-area">
                    <li>
                        <a href="https://www.facebook.com/BrewYourBrandOfficial">
                            <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M7.81526 12.2483V7.46726H9.42818L9.66793 5.59534H7.81526V4.40301C7.81526 3.86284 7.96576 3.49301 8.74101 3.49301H9.72334V1.82409C9.24538 1.77287 8.76495 1.74814 8.28426 1.75001C6.85859 1.75001 5.87976 2.62034 5.87976 4.21809V5.59184H4.27734V7.46376H5.88326V12.2483H7.81526Z">
                                </path>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a href="https://x.com/brew_your_brand">
                            <svg width="12" height="12" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                <g>
                                    <path
                                        d="M11.025 0.65625H13.1722L8.48225 6.0305L14 13.3438H9.68012L6.2965 8.9075L2.42462 13.3438H0.2765L5.29287 7.595L0 0.65625H4.43013L7.48825 4.71012L11.025 0.65625ZM10.2725 12.0557H11.4625L3.78262 1.87687H2.50688L10.2725 12.0557Z">
                                    </path>
                                </g>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/brew-your-brand">
                            <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M2.90719 4.1972C3.61209 4.1972 4.18353 3.62576 4.18353 2.92086C4.18353 2.21597 3.61209 1.64453 2.90719 1.64453C2.20229 1.64453 1.63086 2.21597 1.63086 2.92086C1.63086 3.62576 2.20229 4.1972 2.90719 4.1972Z">
                                </path>
                                <path
                                    d="M5.38752 5.16523V12.2463H7.5861V8.74457C7.5861 7.82057 7.75994 6.92573 8.9056 6.92573C10.0355 6.92573 10.0495 7.98215 10.0495 8.8029V12.2469H12.2493V8.36365C12.2493 6.45615 11.8386 4.99023 9.60911 4.99023C8.53869 4.99023 7.82119 5.57765 7.52777 6.13357H7.49802V5.16523H5.38752ZM1.80469 5.16523H4.00677V12.2463H1.80469V5.16523Z">
                                </path>
                            </svg>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/brew_your_brand">
                            <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12.2191 4.84492C12.2132 4.40312 12.1305 3.96571 11.9747 3.55226C11.8396 3.20351 11.6332 2.88679 11.3687 2.62233C11.1043 2.35786 10.7875 2.15147 10.4388 2.01634C10.0307 1.86313 9.59948 1.78029 9.16362 1.77134C8.60246 1.74626 8.42454 1.73926 7.00004 1.73926C5.57554 1.73926 5.39296 1.73926 4.83587 1.77134C4.40022 1.78036 3.96924 1.8632 3.56129 2.01634C3.21249 2.15138 2.89572 2.35773 2.63124 2.62221C2.36677 2.88669 2.16041 3.20346 2.02537 3.55226C1.87186 3.96008 1.7892 4.39116 1.78096 4.82684C1.75587 5.38859 1.74829 5.56651 1.74829 6.99101C1.74829 8.41551 1.74829 8.59751 1.78096 9.15517C1.78971 9.59151 1.87196 10.022 2.02537 10.4309C2.16064 10.7796 2.36715 11.0963 2.63171 11.3606C2.89628 11.625 3.21308 11.8313 3.56187 11.9663C3.96871 12.1256 4.39976 12.2144 4.83646 12.2288C5.39821 12.2538 5.57612 12.2614 7.00062 12.2614C8.42512 12.2614 8.60771 12.2614 9.16479 12.2288C9.60063 12.2202 10.0318 12.1375 10.44 11.9843C10.7886 11.8491 11.1053 11.6426 11.3697 11.3782C11.6341 11.1137 11.8406 10.7971 11.9759 10.4484C12.1293 10.0401 12.2115 9.60959 12.2203 9.17267C12.2454 8.61151 12.253 8.43359 12.253 7.00851C12.2518 5.58401 12.2518 5.40317 12.2191 4.84492ZM6.99654 9.68484C5.50671 9.68484 4.29979 8.47792 4.29979 6.98809C4.29979 5.49826 5.50671 4.29134 6.99654 4.29134C7.71176 4.29134 8.39769 4.57546 8.90343 5.0812C9.40917 5.58694 9.69329 6.27287 9.69329 6.98809C9.69329 7.70331 9.40917 8.38924 8.90343 8.89498C8.39769 9.40072 7.71176 9.68484 6.99654 9.68484ZM9.80062 4.82042C9.71802 4.8205 9.63622 4.80429 9.55989 4.77271C9.48356 4.74114 9.41421 4.69482 9.3558 4.63641C9.29739 4.57801 9.25108 4.50865 9.2195 4.43233C9.18793 4.356 9.17171 4.27419 9.17179 4.19159C9.17179 4.10905 9.18805 4.02732 9.21964 3.95106C9.25122 3.8748 9.29752 3.80551 9.35589 3.74714C9.41425 3.68878 9.48354 3.64248 9.5598 3.61089C9.63606 3.57931 9.71779 3.56305 9.80033 3.56305C9.88287 3.56305 9.96461 3.57931 10.0409 3.61089C10.1171 3.64248 10.1864 3.68878 10.2448 3.74714C10.3031 3.80551 10.3494 3.8748 10.381 3.95106C10.4126 4.02732 10.4289 4.10905 10.4289 4.19159C10.4289 4.53926 10.1477 4.82042 9.80062 4.82042Z">
                                </path>
                                <path
                                    d="M6.99589 8.73983C7.96336 8.73983 8.74764 7.95554 8.74764 6.98808C8.74764 6.02061 7.96336 5.23633 6.99589 5.23633C6.02843 5.23633 5.24414 6.02061 5.24414 6.98808C5.24414 7.95554 6.02843 8.73983 6.99589 8.73983Z">
                                </path>
                            </svg>
                        </a>
                    </li>
                </ul>
            </div>
            </div>
    </div>

    <div className="header-area2">
        <div className="container d-flex d-lg-flex align-items-center justify-content-between">

            <div className="header-logo d-flex">

                <a href="/e-magazine/"><img alt="Brew Your Brand eMagazine logo" className="img-fluid dark" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg"/></a>

                <p>eMagazine</p>

                {/* <a href="/e-magazine/"><img alt="image" className="img-fluid light" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg"/></a> */}
            </div>
 <div className="header-menu-icon d-lg-none d-sm-block d-md-none">
                <div className="menu-icon" onClick={handleHamburgerMenu}>
                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M1.66675 9.16666H18.3334V10.8333H1.66675V9.16666ZM1.66675 4.16666H18.3334V5.83332H1.66675V4.16666ZM1.66675 14.1667H18.3334V15.8333H1.66675V14.1667Z" />
                    </svg>
                </div>
                <div className="tt-style-switch" onClick={handleThemeSwitch}>
                    <i className="bi bi-brightness-low-fill"></i>
                </div>
            </div>

            <div className="header-right d-md-flex d-lg-block d-none">
                <div className="search-bar">
                    {/* <div className="search-btn">
                        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M7.67458 2.95934C5.06925 2.95934 2.95925 5.06868 2.95925 7.66868C2.95925 10.2687 5.06925 12.3773 7.67458 12.3773C8.97459 12.3773 10.1499 11.8533 11.0033 11.004C11.4434 10.5674 11.7926 10.0477 12.0307 9.47524C12.2687 8.90273 12.3908 8.28869 12.3899 7.66868C12.3899 5.06868 10.2799 2.95934 7.67458 2.95934ZM1.33325 7.66868C1.33325 4.16868 4.17325 1.33334 7.67458 1.33334C11.1759 1.33334 14.0159 4.16868 14.0159 7.66868C14.0178 9.07185 13.5516 10.4356 12.6913 11.544L14.4279 13.2787C14.5084 13.353 14.573 13.4427 14.618 13.5426C14.6629 13.6424 14.6872 13.7503 14.6894 13.8598C14.6916 13.9693 14.6717 14.0781 14.6309 14.1797C14.59 14.2813 14.5291 14.3736 14.4517 14.4511C14.3743 14.5286 14.2821 14.5896 14.1805 14.6306C14.079 14.6716 13.9702 14.6916 13.8607 14.6895C13.7512 14.6874 13.6433 14.6632 13.5434 14.6184C13.4435 14.5736 13.3536 14.5091 13.2793 14.4287L11.5393 12.6913C10.4316 13.544 9.07244 14.0054 7.67458 14.0033C4.17325 14.0033 1.33325 11.168 1.33325 7.66868Z" />
                        </svg>
                    </div> */}
                    <div className="search-input">
                        <div className="serch-close"></div>
                        <form>
                            <div className="search-group">
                                <div className="form-inner2">
                                    <input type="text" placeholder="Enter your keywords"/>
                                    <button type="submit">
                                        <svg width="16" height="16" viewBox="0 0 16 16"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M7.67458 2.95934C5.06925 2.95934 2.95925 5.06868 2.95925 7.66868C2.95925 10.2687 5.06925 12.3773 7.67458 12.3773C8.97459 12.3773 10.1499 11.8533 11.0033 11.004C11.4434 10.5674 11.7926 10.0477 12.0307 9.47524C12.2687 8.90273 12.3908 8.28869 12.3899 7.66868C12.3899 5.06868 10.2799 2.95934 7.67458 2.95934ZM1.33325 7.66868C1.33325 4.16868 4.17325 1.33334 7.67458 1.33334C11.1759 1.33334 14.0159 4.16868 14.0159 7.66868C14.0178 9.07185 13.5516 10.4356 12.6913 11.544L14.4279 13.2787C14.5084 13.353 14.573 13.4427 14.618 13.5426C14.6629 13.6424 14.6872 13.7503 14.6894 13.8598C14.6916 13.9693 14.6717 14.0781 14.6309 14.1797C14.59 14.2813 14.5291 14.3736 14.4517 14.4511C14.3743 14.5286 14.2821 14.5896 14.1805 14.6306C14.079 14.6716 13.9702 14.6916 13.8607 14.6895C13.7512 14.6874 13.6433 14.6632 13.5434 14.6184C13.4435 14.5736 13.3536 14.5091 13.2793 14.4287L11.5393 12.6913C10.4316 13.544 9.07244 14.0054 7.67458 14.0033C4.17325 14.0033 1.33325 11.168 1.33325 7.66868Z" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            <div className="quick-search">
                                <ul>
                                    <li>Quick Search :</li>
                                    <li><a href={buildEmagazineCategoryPath("Beauty")}>Beauty,</a></li>
                                    <li><a href={buildEmagazineCategoryPath("Gaming Tips")}>Gaming Tips,</a></li>
                                    <li><a href={buildEmagazineCategoryPath("Fashion")}>Fashion,</a></li>
                                    <li><a href={buildEmagazineCategoryPath("Tech")}>Tech,</a></li>
                                </ul>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="subscribe-btn ">
                    <a href="#" className="primary-btn hover-btn">
                        <svg className="arrow" width="11" height="11" viewBox="0 0 11 11"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.999756 10L9.99976 1M9.99976 1C7.99976 1.375 3.62476 2.125 0.999756 1M9.99976 1C9.62476 2.875 8.87476 7 9.99976 10"
                                stroke="#191919" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                        SUBSCRIBE
                    </a>

                </div>
            </div>
        </div>
    </div>

    <header className="life-style d-lg-flex d-lg-block d-none d-md-block bg-transparent">
        <div className="container-md">
            <div className="col-lg-12 px-0">
                <div className="header-wrapper">
                    <div className="main-menu">
                        <ul className="menu-list">
                            {/* <li className="menu-item-has-children active">
                                <ul className="sub-menu">
                                {categories.map(category => (
                                        <li key={category.id}>
                                            <a href={getCategoryHref(category.name)}>
                                                {category.name}
                                            </a>
                                        </li>
                                    ))}

                                </ul>
                            </li> */}
                            {categories.map(category => (
    <li key={category.id}>
        <a href={getCategoryHref(category.name)}>
            {category.name}
        </a>
    </li>
))}

                            {/* <li class="menu-item-has-children">
                                <a href="#" class="drop-down">POST FEATURES</a><i class="bi bi-plus dropdown-icon"></i>
                                <ul class="sub-menu">
                                    <li><a href="https://brewyourbrand.in/brandselfauditkit">About Us</a></li>
                                    <li><a href="faq/index.html">FAQ's </a></li>
                                    <li><a href="/e-magazine/terms-and-conditions/">Terms & Conditions </a></li>
                                    <li><a href="privacy-policy/index.html">Privacy Policy</a></li>
                                </ul>
                            </li>
                            <li><a href="contact-us/index.html">CONTACT</a></li> */}
                        </ul>
                    </div>
                    <div className="nav-right d-flex jsutify-content-end align-items-center">
                        <ul className="social-area">
                            <li>
                                <a href="https://www.facebook.com/">
                                    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.81526 12.2483V7.46726H9.42818L9.66793 5.59534H7.81526V4.40301C7.81526 3.86284 7.96576 3.49301 8.74101 3.49301H9.72334V1.82409C9.24538 1.77287 8.76495 1.74814 8.28426 1.75001C6.85859 1.75001 5.87976 2.62034 5.87976 4.21809V5.59184H4.27734V7.46376H5.88326V12.2483H7.81526Z">
                                        </path>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://x.com/">
                                    <svg width="12" height="12" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                        <g>
                                            <path
                                                d="M11.025 0.65625H13.1722L8.48225 6.0305L14 13.3438H9.68012L6.2965 8.9075L2.42462 13.3438H0.2765L5.29287 7.595L0 0.65625H4.43013L7.48825 4.71012L11.025 0.65625ZM10.2725 12.0557H11.4625L3.78262 1.87687H2.50688L10.2725 12.0557Z">
                                            </path>
                                        </g>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/">
                                    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.90719 4.1972C3.61209 4.1972 4.18353 3.62576 4.18353 2.92086C4.18353 2.21597 3.61209 1.64453 2.90719 1.64453C2.20229 1.64453 1.63086 2.21597 1.63086 2.92086C1.63086 3.62576 2.20229 4.1972 2.90719 4.1972Z">
                                        </path>
                                        <path
                                            d="M5.38752 5.16523V12.2463H7.5861V8.74457C7.5861 7.82057 7.75994 6.92573 8.9056 6.92573C10.0355 6.92573 10.0495 7.98215 10.0495 8.8029V12.2469H12.2493V8.36365C12.2493 6.45615 11.8386 4.99023 9.60911 4.99023C8.53869 4.99023 7.82119 5.57765 7.52777 6.13357H7.49802V5.16523H5.38752ZM1.80469 5.16523H4.00677V12.2463H1.80469V5.16523Z">
                                        </path>
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/">
                                    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12.2191 4.84492C12.2132 4.40312 12.1305 3.96571 11.9747 3.55226C11.8396 3.20351 11.6332 2.88679 11.3687 2.62233C11.1043 2.35786 10.7875 2.15147 10.4388 2.01634C10.0307 1.86313 9.59948 1.78029 9.16362 1.77134C8.60246 1.74626 8.42454 1.73926 7.00004 1.73926C5.57554 1.73926 5.39296 1.73926 4.83587 1.77134C4.40022 1.78036 3.96924 1.8632 3.56129 2.01634C3.21249 2.15138 2.89572 2.35773 2.63124 2.62221C2.36677 2.88669 2.16041 3.20346 2.02537 3.55226C1.87186 3.96008 1.7892 4.39116 1.78096 4.82684C1.75587 5.38859 1.74829 5.56651 1.74829 6.99101C1.74829 8.41551 1.74829 8.59751 1.78096 9.15517C1.78971 9.59151 1.87196 10.022 2.02537 10.4309C2.16064 10.7796 2.36715 11.0963 2.63171 11.3606C2.89628 11.625 3.21308 11.8313 3.56187 11.9663C3.96871 12.1256 4.39976 12.2144 4.83646 12.2288C5.39821 12.2538 5.57612 12.2614 7.00062 12.2614C8.42512 12.2614 8.60771 12.2614 9.16479 12.2288C9.60063 12.2202 10.0318 12.1375 10.44 11.9843C10.7886 11.8491 11.1053 11.6426 11.3697 11.3782C11.6341 11.1137 11.8406 10.7971 11.9759 10.4484C12.1293 10.0401 12.2115 9.60959 12.2203 9.17267C12.2454 8.61151 12.253 8.43359 12.253 7.00851C12.2518 5.58401 12.2518 5.40317 12.2191 4.84492ZM6.99654 9.68484C5.50671 9.68484 4.29979 8.47792 4.29979 6.98809C4.29979 5.49826 5.50671 4.29134 6.99654 4.29134C7.71176 4.29134 8.39769 4.57546 8.90343 5.0812C9.40917 5.58694 9.69329 6.27287 9.69329 6.98809C9.69329 7.70331 9.40917 8.38924 8.90343 8.89498C8.39769 9.40072 7.71176 9.68484 6.99654 9.68484ZM9.80062 4.82042C9.71802 4.8205 9.63622 4.80429 9.55989 4.77271C9.48356 4.74114 9.41421 4.69482 9.3558 4.63641C9.29739 4.57801 9.25108 4.50865 9.2195 4.43233C9.18793 4.356 9.17171 4.27419 9.17179 4.19159C9.17179 4.10905 9.18805 4.02732 9.21964 3.95106C9.25122 3.8748 9.29752 3.80551 9.35589 3.74714C9.41425 3.68878 9.48354 3.64248 9.5598 3.61089C9.63606 3.57931 9.71779 3.56305 9.80033 3.56305C9.88287 3.56305 9.96461 3.57931 10.0409 3.61089C10.1171 3.64248 10.1864 3.68878 10.2448 3.74714C10.3031 3.80551 10.3494 3.8748 10.381 3.95106C10.4126 4.02732 10.4289 4.10905 10.4289 4.19159C10.4289 4.53926 10.1477 4.82042 9.80062 4.82042Z">
                                        </path>
                                        <path
                                            d="M6.99589 8.73983C7.96336 8.73983 8.74764 7.95554 8.74764 6.98808C8.74764 6.02061 7.96336 5.23633 6.99589 5.23633C6.02843 5.23633 5.24414 6.02061 5.24414 6.98808C5.24414 7.95554 6.02843 8.73983 6.99589 8.73983Z">
                                        </path>
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </header>


    <div className="inner-page-banner-section ">

    {/* <header className="slid_txt" aria-label="Featured eBook">
    <p>eBook <span></span> {EBOOK_CTA_TITLE}
        <a
            href={EBOOK_CTA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-white text-decoration-underline"
            aria-label={`Download eBook: ${EBOOK_CTA_TITLE}`}
            onClick={() => trackEbookCtaClick("category_banner")}
            {...getEbookCtaTrackingAttributes()}
        >Download Now</a>
    </p>
  </header> */}

    <div className="container">
        <div className="row">
            <div className="col-lg-12">
                <div
                    className="inner-page-banner-wrapper"
                    // style={{ backgroundImage: 'url(../../../src/pages/emagazine/assets/image/life-style/Background-7.png)' }}
                >
                    <div className="banner-content">
                        <h1>{categoryName}</h1>

                        <ul className="breadcrumb-list">
                            <li><a href="/e-magazine/" className='text-decoration-none'>Home</a></li>
                            <li>{categoryName}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>


    <div className="blog-post-8 pt-70">

    {/* <header class="slid_txt">
    <p>eBook - Outsourcing Creative Work to AI Integrated Agencies in 2025
        <a href="https://skepper.in/ebook/ai-integrated-agencies-2025" target="_blank" class="text-white text-decoration-underline">Download</a>
    </p>
  </header> */}

        <div className="container">
            <div className="row g-lg-4 gy-5">
            <div className="col-lg-8">
            <div className="row gy-5 mb-50">
                {showCategoryComingSoon && (
                    <div className="col-12">
                        <section className="emagazine-empty-category" aria-labelledby="empty-category-title">
                            <p className="emagazine-empty-category-eyebrow">Coming Soon</p>
                            <h2 id="empty-category-title">{categoryName} is brewing.</h2>
                            <p>
                                We are curating fresh {categoryName.toLowerCase()} content for Brew Your Brand eMagazine. Subscribe to get the first update when this section goes live.
                            </p>
                            <form className="emagazine-empty-category-form" onSubmit={handleCategorySubscribe}>
                                <input
                                    type="email"
                                    value={subscriberEmail}
                                    onChange={(event) => setSubscriberEmail(event.target.value)}
                                    placeholder="Enter your email"
                                    aria-label="Email address"
                                />
                                <button type="submit">Subscribe</button>
                            </form>
                            {subscriberMessage && (
                                <p className={`emagazine-empty-category-message ${subscriberMessageType}`}>
                                    {subscriberMessage}
                                </p>
                            )}
                        </section>
                    </div>
                )}
                {blogs.map((blog, index) => (
                    <div className="col-md-6" key={index}>
                        <div className="blog-card2 two">
                            <div className="blog-card-img-wrap">
                                <a href={buildEmagazineArticlePath(blog.category, blog.slug)}>
                                    <img
                                        src={buildEmagazineUploadUrl(blog.image2)}
                                        alt={blog.title ? `${blog.title} article thumbnail` : "BYB eMagazine category article thumbnail"}
                                    />
                                </a>
                                <ul className='px-0'>
                                    <li>
                                        <a className="category" href={buildEmagazineCategoryPath(blog.category)}>{blog.tags}</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="blog-content">
                                <ul className="blog-meta">
                                    <li>
                                        <a href={buildAuthorPath(getArticleAuthorName(blog)) || "#"} className='text-white'>{getArticleAuthorName(blog) || blog.author}</a>
                                    </li>
                                    <li>
                                        <a className="publish-date text-white">
                                            {new Date(blog.created_at).toLocaleDateString("en-US", {
                                                day: "2-digit", month: "short", year: "numeric"
                                            })}
                                        </a>
                                    </li>
                                </ul>
                                <h4>
                                    <a href={buildEmagazineArticlePath(blog.category, blog.slug)} className='text-white text-decoration-none'>{blog.title}</a>
                                </h4>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Load More Button (Optional) */}
            {blogs.length === 10 && (
                <div className="load-more-btn">
                    <a href="#" className="hover-btn">
                        LOAD MORE
                        <svg className="arrow" width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M1 9L9 1M9 1C7.22222 1.33333 3.33333 2 1 1M9 1C8.66667 2.66667 8 6.33333 9 9"
                                stroke="#191919" strokeWidth="1.5" strokeLinecap="round"
                            ></path>
                        </svg>
                    </a>
                </div>
            )}
        </div>
                <div className="col-lg-4 ">
                    <div className="life-style-sidebar">
                        {/* <div className="sidebar-widget driscription">
                            <div className="header-logo pb-15">
                                <a href="index.html"><img alt="image" className="img-fluid dark" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg"/></a>
                                <a href="index.html"><img alt="image" className="img-fluid light" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg"/></a>
                            </div>
                            <p><span>Welcome!</span> Feel free to mix and match these subcategories based on your   interests and the preferences of your target audience. Health &amp; Wellness is a diverse niche.</p>
                            <div className="counter-area">
                                <ul>
                                    <li className="single-counter">
                                        <a href="https://www.facebook.com/">
                                            <div className="icon">
                                                <svg width="6" height="12" viewBox="0 0 6 12" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.81526 11.2482V6.46723H5.42818L5.66793 4.59531H3.81526V3.40298C3.81526 2.86281 3.96576 2.49298 4.74101 2.49298H5.72334V0.82406C5.24538 0.772838 4.76495 0.748106 4.28426 0.749977C2.85859 0.749977 1.87976 1.62031 1.87976 3.21806V4.59181H0.277344V6.46373H1.88326V11.2482H3.81526Z"></path>
                                                </svg>
                                            </div>
                                            <div className="number">
                                                <h5 className="counter">222</h5>
                                                <span>K</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li className="single-counter">
                                        <a href="https://youtube.com/">
                                            <div className="icon">
                                                <svg width="14" height="11" viewBox="0 0 14 11" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M7.04462 0.749146H7.1225C7.84175 0.751771 11.4861 0.778021 12.4688 1.04227C12.7658 1.12292 13.0365 1.28012 13.2538 1.49815C13.471 1.71619 13.6273 1.98743 13.7069 2.28477C13.7952 2.61727 13.8574 3.0574 13.8994 3.51152L13.9081 3.60252L13.9274 3.83002L13.9344 3.92102C13.9913 4.72077 13.9983 5.46977 13.9991 5.6334V5.69902C13.9983 5.86877 13.9904 6.66852 13.9274 7.50152L13.9204 7.5934L13.9125 7.6844C13.8687 8.1849 13.804 8.6819 13.7069 9.04765C13.6273 9.34499 13.471 9.61623 13.2538 9.83426C13.0365 10.0523 12.7658 10.2095 12.4688 10.2901C11.4537 10.5631 7.59587 10.5824 7.06125 10.5833H6.937C6.66663 10.5833 5.54838 10.578 4.37587 10.5378L4.22712 10.5325L4.151 10.529L4.00138 10.5229L3.85175 10.5168C2.8805 10.4739 1.95563 10.4048 1.5295 10.2893C1.23255 10.2087 0.961931 10.0516 0.74467 9.83376C0.527409 9.61588 0.371108 9.34482 0.291375 9.04765C0.19425 8.68277 0.1295 8.1849 0.08575 7.6844L0.07875 7.59252L0.07175 7.50152C0.028318 6.90863 0.0043884 6.31448 0 5.72002L0 5.6124C0.00175 5.42427 0.00875 4.77415 0.056 4.05665L0.062125 3.96652L0.06475 3.92102L0.07175 3.83002L0.091 3.60252L0.09975 3.51152C0.14175 3.0574 0.203875 2.6164 0.29225 2.28477C0.371849 1.98743 0.528091 1.71619 0.74536 1.49815C0.96263 1.28012 1.23332 1.12292 1.53038 1.04227C1.9565 0.928521 2.88137 0.85852 3.85262 0.81477L4.00138 0.808645L4.15188 0.803396L4.22712 0.800771L4.37675 0.794646C5.2095 0.767874 6.04258 0.752997 6.87575 0.750021L7.04462 0.749146ZM5.6 3.5579V7.77365L9.23738 5.66665L5.6 3.5579Z"></path>
                                                </svg>
                                            </div>
                                            <div className="number">
                                                <h5 className="counter">222</h5>
                                                <span>K</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li className="single-counter">
                                        <a href="https://www.instagram.com/">
                                            <div className="icon">
                                                <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.2189 3.84492C11.213 3.40312 11.1303 2.96571 10.9745 2.55226C10.8393 2.20351 10.6329 1.88679 10.3685 1.62233C10.104 1.35786 9.78729 1.15147 9.43855 1.01634C9.03041 0.863133 8.59923 0.78029 8.16338 0.771341C7.60221 0.746258 7.4243 0.739258 5.9998 0.739258C4.5753 0.739258 4.39271 0.739258 3.83563 0.771341C3.39997 0.780356 2.969 0.863198 2.56105 1.01634C2.21225 1.15138 1.89548 1.35773 1.631 1.62221C1.36652 1.88669 1.16017 2.20346 1.02513 2.55226C0.871615 2.96008 0.788952 3.39116 0.780714 3.82684C0.75563 4.38859 0.748047 4.56651 0.748047 5.99101C0.748047 7.41551 0.748047 7.59751 0.780714 8.15517C0.789464 8.59151 0.871713 9.02201 1.02513 9.43092C1.16039 9.77962 1.3669 10.0963 1.63147 10.3606C1.89603 10.625 2.21283 10.8313 2.56163 10.9663C2.96847 11.1256 3.39951 11.2144 3.83621 11.2288C4.39796 11.2538 4.57588 11.2614 6.00038 11.2614C7.42488 11.2614 7.60746 11.2614 8.16455 11.2288C8.60039 11.2202 9.03159 11.1375 9.43971 10.9843C9.78837 10.8491 10.105 10.6426 10.3695 10.3782C10.6339 10.1137 10.8403 9.79708 10.9756 9.44842C11.129 9.04009 11.2113 8.60959 11.22 8.17267C11.2451 7.61151 11.2527 7.43359 11.2527 6.00851C11.2515 4.58401 11.2515 4.40317 11.2189 3.84492V3.84492ZM5.9963 8.68484C4.50646 8.68484 3.29955 7.47792 3.29955 5.98809C3.29955 4.49826 4.50646 3.29134 5.9963 3.29134C6.71152 3.29134 7.39745 3.57546 7.90319 4.0812C8.40893 4.58694 8.69305 5.27287 8.69305 5.98809C8.69305 6.70331 8.40893 7.38924 7.90319 7.89498C7.39745 8.40072 6.71152 8.68484 5.9963 8.68484V8.68484ZM8.80038 3.82042C8.71778 3.8205 8.63597 3.80429 8.55965 3.77271C8.48332 3.74114 8.41397 3.69482 8.35556 3.63641C8.29715 3.57801 8.25083 3.50865 8.21926 3.43233C8.18768 3.356 8.17147 3.27419 8.17155 3.19159C8.17155 3.10905 8.1878 3.02732 8.21939 2.95106C8.25098 2.8748 8.29728 2.80551 8.35564 2.74714C8.41401 2.68878 8.4833 2.64248 8.55956 2.61089C8.63581 2.57931 8.71755 2.56305 8.80009 2.56305C8.88263 2.56305 8.96436 2.57931 9.04062 2.61089C9.11688 2.64248 9.18617 2.68878 9.24453 2.74714C9.3029 2.80551 9.3492 2.8748 9.38079 2.95106C9.41237 3.02732 9.42863 3.10905 9.42863 3.19159C9.42863 3.53926 9.14746 3.82042 8.80038 3.82042Z"></path>
                                                    <path d="M5.99589 7.73983C6.96336 7.73983 7.74764 6.95554 7.74764 5.98808C7.74764 5.02061 6.96336 4.23633 5.99589 4.23633C5.02843 4.23633 4.24414 5.02061 4.24414 5.98808C4.24414 6.95554 5.02843 7.73983 5.99589 7.73983Z"></path>
                                                </svg>
                                            </div>
                                            <div className="number">
                                                <h5 className="counter">222</h5>
                                                <span>K</span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div> */}
                        <div className="sidebar-widget featured-post">
                            <h6>Featured Post</h6>
                            {posts.map((post) => (
                                <div className="recent-post mb-20" key={post.id}>
                                    <div className="recent-post-img">
                                    <a href={buildEmagazineArticlePath(post.category, post.slug)}>
                                            <img
                                                src={buildEmagazineUploadUrl(post.image3)}
                                                alt={post.title ? `${post.title} featured article thumbnail` : "Featured BYB eMagazine article thumbnail"}
                                                onError={(e) => (e.target.style.display = "none")}
                                            />
                                        </a>
                                    </div>
                                    <div className="recent-post-content">
                                        <a href={buildEmagazineArticlePath(post.category, post.slug)}>
                                            {new Date(post.created_at).toLocaleDateString("en-US", {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric",
                                            })}
                                        </a>
                                        <h5>
                                            <a href={buildEmagazineArticlePath(post.category, post.slug)}>{post.title}</a>
                                        </h5>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* <div className="sidebar-widget about-section mb-40">
                            <ul className="category">
                                <li>
                                    <a href="https://brewyourbrand.in/brandselfauditkit">About Us</a>
                                </li>
                                <li>
                                    <a href="/e-magazine/terms-and-conditions/">Terms & Conditions</a>
                                </li>
                                <li>
                                    <a href="#">Support</a>
                                </li>
                                <li>
                                    <a href="privacy-policy.html">Privacy Policy</a>
                                </li>
                            </ul>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    </div>

           <BybFooter/>

   </div>
        </>
    );
};



export default CategoryPage;
